import { useContext, useRef, useState } from "react";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import {
  ContactListFilters,
  createContactGat,
  deleteContactGat,
  getContactByEmailGat,
  getContactGat,
  getContactsByUserIdGat,
  updateContactGat,
} from "../../gateways/ContactsGateway";

export interface ContactType {
  id?: string;
  name: string;
  email: string;
  phoneNumber: string;
}

export default function useContact() {
  const showToast = useToast();
  const { setLoading } = useContext(LoadingContext);
  const { objUserTk } = useContext(AuthContext);

  const [formValuesContact, setFormValuesContact] = useState<ContactType>({
    email: "",
    name: "",
    phoneNumber: "",
  });
  const [tableContacts, setTableContacts] = useState<any[]>([]);
  const [totalContats, setTotalContact] = useState<number>(0);
  const lastListFiltersRef = useRef<ContactListFilters>({});

  const updateContact = async (contactData?: Partial<ContactType>) => {
    try {
      setLoading(true);

      const data = {
        ...formValuesContact,
        ...contactData,
        userId: objUserTk.UserId,
      };

      const result = await updateContactGat(data);
      if (result) {
        showToast("success", "Sucesso ao atualizar");
        setLoading(false);
        getContactsByUserId(1);
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
    }
  };

  const createContact = async (contactData?: Partial<ContactType>) => {
    try {
      setLoading(true);

      const data = {
        ...formValuesContact,
        ...contactData,
        userId: objUserTk.UserId,
      };

      const hasContract = await getContactByEmail(data.email, data.userId);

      if (hasContract) {
        showToast("info", "E-mail já cadastrado");
        setLoading(false);
        return;
      }

      const result = await createContactGat(data);
      if (result) {
        showToast("success", "Sucesso ao cadastrar");
        setLoading(false);
        getContactsByUserId(1);
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
    }
  };

  const deleteContact = async (id: string) => {
    try {
      setLoading(true);

      const result = await deleteContactGat(id);
      if (result) {
        showToast("success", "Sucesso ao deletar");
        setLoading(false);
        getContactsByUserId(1)
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
    }
  };

  const getContact = async (id: string) => {
    try {
      setLoading(true);

      const result = await getContactGat(id);
      if (result) {
        setFormValuesContact(result.data?.data);
        setLoading(false);
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao carregar"
      );
      setLoading(false);
    }
  };

  const getContactByEmail = async (email: string, userId: string) => {
    try {
      const result = await getContactByEmailGat(email, userId);
      if (result) {
        return result.data?.data;
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao carregar"
      );
    }
  };

  const getContactsByUserId = async (
    page: number,
    filters?: ContactListFilters
  ) => {
    try {
      setLoading(true);
      const effectiveFilters =
        filters !== undefined ? filters : lastListFiltersRef.current;
      if (filters !== undefined) {
        lastListFiltersRef.current = filters;
      }

      const result = await getContactsByUserIdGat(
        objUserTk.UserId,
        page,
        5,
        effectiveFilters
      );
      if (result) {
        const totalContacts = result.data?.data?.totalContacts ?? 0;
        setTotalContact(
          totalContacts === 0 ? 0 : Math.ceil(totalContacts / 5)
        );

        const tableResult = result.data?.data?.contacts?.map((item: any) => ({
          id: item.id,
          name: item.name,
          email: item.email,
          phoneNumber: item.phoneNumber,
        }));
        setTableContacts(tableResult);
        setLoading(false);
        return result.data.data;
      }
    } catch (error: any) {
      console.log(error);
      showToast("error", error?.message || "Erro ao cadastrar");
      setLoading(false);
    }
  };

  return {
    getContactsByUserId,
    deleteContact,
    createContact,
    updateContact,
    getContact,
    setFormValuesContact,
    formValuesContact,
    tableContacts,
    totalContats,
    getContactByEmail
  };
}
